import { render, staticRenderFns } from "./ContentViewSettingModalActions.vue?vue&type=template&id=613c735d&"
import script from "./ContentViewSettingModalActions.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingModalActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports